<app-breadcrumb [title]="'Archivo y Retención'" [items]="['Implementacion']" [active_item]="'Archivo y Retención'">
</app-breadcrumb>

<div class="container-fluid">

  <!-- Título -->
  <div class="mb-3">
    <h5 class="mb-0 fw-semibold">{{ documento_id ? 'Editando documento' : 'Nuevo documento' }}</h5>
    <small class="text-primary" *ngIf="documento_id">ID: {{ documento_id }}</small>
  </div>

  <div *ngIf="cargandoCatalogos || cargandoDocumento" class="d-flex align-items-center text-primary mb-3">
    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
    Cargando información del documento...
  </div>

  <ngb-accordion [closeOthers]="true" [activeIds]="activePanel" [destroyOnHide]="false" #accordion="ngbAccordion">

    <!-- PANEL 1: REGISTRO MAESTRO DE DOCUMENTO -->
    <ngb-panel id="static-1">
      <ng-template ngbPanelTitle>
        <i class="fa fa-file-text me-2 text-primary"></i>
        <span (click)="togglePanel('static-1')" class="fw-semibold">Registro maestro de documento</span>
      </ng-template>
      <ng-template ngbPanelContent>
        <form [ngClass]="{ 'was-validated': validate }" class="needs-validation" novalidate>

          <h6 class="fw-semibold mb-3">Información general</h6>
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label" for="codigo">Código del documento <span class="text-danger">*</span></label>
              <input type="text" id="codigo" class="form-control" [(ngModel)]="formData.codigo"
                (ngModelChange)="actualizarRutaPreview()" name="codigo" placeholder="Ej: PR-PESV-01" required
                [ngClass]="{ 'is-invalid': errores.codigo }">
              <div class="invalid-feedback">{{ errores.codigo }}</div>
            </div>

            <div class="col-md-6">
              <label class="form-label" for="nombre_documento">Nombre del documento <span class="text-danger">*</span></label>
              <ng-select id="nombre_documento" [loading]="cargandoCatalogos" [items]="nombresDocumentos" bindLabel="nombre_documento" bindValue="id"
                placeholder="Seleccione una opción" [(ngModel)]="formData.nombre_documento" name="nombre_documento"
                [ngClass]="{ 'is-invalid': errores.nombre_documento }">
              </ng-select>
              <div class="invalid-feedback">{{ errores.nombre_documento }}</div>
            </div>

            <div class="col-md-4">
              <label class="form-label" for="tipo_documental">Tipo documental <span class="text-danger">*</span></label>
              <ng-select id="tipo_documental" [loading]="cargandoCatalogos" [items]="tiposDocumentales" bindLabel="nombre" bindValue="id"
                placeholder="Seleccione una opción" [(ngModel)]="formData.tipo_documental"
                (change)="actualizarRutaPreview()" name="tipo_documental"
                [ngClass]="{ 'is-invalid': errores.tipo_documental }">
              </ng-select>
              <div class="invalid-feedback">{{ errores.tipo_documental }}</div>
            </div>

            <div class="col-md-4">
              <label class="form-label" for="pilar">Pilar PESV</label>
              <ng-select id="pilar" [loading]="cargandoCatalogos" [items]="pilaresPesv" bindLabel="nombre" bindValue="id"
                placeholder="Seleccione una opción" [(ngModel)]="formData.pilar" name="pilar">
              </ng-select>
            </div>

            <div class="col-md-4">
              <label class="form-label" for="estado">Estado <span class="text-danger">*</span></label>
              <ng-select id="estado" [loading]="cargandoCatalogos" [items]="estadosDocumento" bindLabel="nombre" bindValue="id"
                placeholder="Seleccione una opción" [(ngModel)]="formData.estado" name="estado"
                [ngClass]="{ 'is-invalid': errores.estado }">
              </ng-select>
              <div class="invalid-feedback">{{ errores.estado }}</div>
            </div>

            <div class="col-md-4">
              <label class="form-label" for="retencion">Retención (años) <span class="text-danger">*</span></label>
              <input type="number" id="retencion" class="form-control" [(ngModel)]="formData.retencion"
                name="retencion" placeholder="Años" min="0" step="1" required
                [ngClass]="{ 'is-invalid': errores.retencion }">
              <div class="invalid-feedback">{{ errores.retencion }}</div>
            </div>

            <div class="col-12">
              <label class="form-label" for="observaciones">Observaciones</label>
              <textarea id="observaciones" class="form-control" [(ngModel)]="formData.observaciones"
                name="observaciones" rows="2" placeholder="Notas adicionales"></textarea>
            </div>
          </div>

          <div class="d-flex justify-content-end border-top mt-4 pt-3">
            <button type="button" class="btn btn-primary" (click)="guardarDocumento()"
              [disabled]="guardandoDocumento || cargandoDocumento">
              <span *ngIf="guardandoDocumento" class="spinner-border spinner-border-sm me-1" role="status"
                aria-hidden="true"></span>
              <i *ngIf="!guardandoDocumento" class="fa fa-save me-1"></i>{{ guardandoDocumento ? 'Guardando...' : (documento_id ? 'Actualizar documento' : 'Guardar documento') }}
            </button>
          </div>
        </form>
      </ng-template>
    </ngb-panel>

    <!-- PANEL 2: CONTROL DE VERSIONES -->
    <ngb-panel id="static-2">
      <ng-template ngbPanelTitle>
        <i class="fa fa-history me-2 text-primary"></i>
        <span (click)="togglePanel('static-2')" class="fw-semibold">Control de versiones</span>
      </ng-template>
      <ng-template ngbPanelContent>
        <form [ngClass]="{ 'was-validated': validate }" class="needs-validation" novalidate>
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label" for="numero_version">Número de versión <span class="text-danger">*</span></label>
              <input type="text" id="numero_version" class="form-control" [(ngModel)]="versionData.numero_version"
                (ngModelChange)="actualizarRutaPreview()" name="numero_version" placeholder="01" required
                [ngClass]="{ 'is-invalid': errores.numero_version }">
              <div class="invalid-feedback">{{ errores.numero_version }}</div>
            </div>

            <div class="col-md-4">
              <label class="form-label" for="fecha_aprobacion">Fecha de aprobación</label>
              <input type="date" id="fecha_aprobacion" class="form-control" [(ngModel)]="versionData.fecha_aprobacion"
                name="fecha_aprobacion" [max]="hoy">
            </div>

            <div class="col-md-4">
              <label class="form-label" for="aprobado_por">Aprobado por</label>
              <input type="text" id="aprobado_por" class="form-control" [(ngModel)]="versionData.aprobado_por"
                name="aprobado_por" placeholder="Nombre del aprobador">
            </div>

            <div class="col-md-8">
              <label class="form-label" for="archivo">Cargar archivo</label>
              <input type="file" id="archivo" #archivoInput class="form-control"
                accept=".pdf,.doc,.docx,.xls,.xlsx"
                (change)="onArchivoSeleccionado($event)" name="archivo">
              <div class="form-text text-break" *ngIf="rutaArchivoPreview">
                Ruta GCP: <span class="font-monospace">{{ rutaArchivoPreview }}</span>
              </div>
            </div>

            <div class="col-md-4 d-flex align-items-end">
              <div class="border rounded-3 p-2 px-3 w-100"
                [ngClass]="versionData.es_vigente ? 'border-success bg-light-success' : 'bg-light'">
                <div class="form-check form-switch mb-0">
                  <input type="checkbox" class="form-check-input" role="switch" id="chkVersionVigente"
                    [(ngModel)]="versionData.es_vigente" name="es_vigente">
                  <label class="form-check-label fw-semibold" for="chkVersionVigente">
                    <i class="fa fa-star me-1" [ngClass]="versionData.es_vigente ? 'text-warning' : 'text-muted'"></i>
                    Marcar como versión vigente
                  </label>
                </div>
                <small class="text-muted d-block ms-5">
                  {{ versionData.es_vigente ? 'Reemplazará a la versión vigente actual.' : 'La versión se guardará como no vigente.' }}
                </small>
              </div>
            </div>
          </div>

          <div class="d-flex justify-content-end border-top mt-4 pt-3">
            <button type="button" class="btn btn-primary" (click)="registrarVersion()"
              [disabled]="!documento_id || guardandoVersion">
              <span *ngIf="guardandoVersion" class="spinner-border spinner-border-sm me-1" role="status"
                aria-hidden="true"></span>
              <i *ngIf="!guardandoVersion" class="fa fa-plus me-1"></i>{{ guardandoVersion ? 'Registrando...' : 'Registrar versión' }}
            </button>
          </div>
        </form>

        <div *ngIf="cargandoVersiones && versiones.length === 0" class="text-center text-primary py-4 mt-3">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Cargando versiones...
        </div>

        <!-- Tabla de versiones -->
        <div class="mt-4" *ngIf="versiones.length > 0">
          <h6 class="fw-semibold mb-3">
            Versiones registradas
            <span class="badge badge-light-secondary ms-1">{{ versiones.length }}</span>
          </h6>
          <div class="table-responsive border rounded-3">
            <table class="table table-hover align-middle mb-0">
              <thead class="table-light">
                <tr>
                  <th>Versión</th>
                  <th>Fecha aprobación</th>
                  <th>Aprobado por</th>
                  <th>Vigente</th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let version of versiones; trackBy: trackById" [class.table-active]="version.es_vigente">
                  <td><span class="badge badge-light-info font-monospace">v{{ version.numero_version }}</span></td>
                  <td class="text-nowrap">{{ version.fecha_aprobacion | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ version.aprobado_por || '-' }}</td>
                  <td>
                    <span *ngIf="version.es_vigente" class="badge rounded-pill badge-light-success">
                      <i class="fa fa-check me-1"></i>Vigente
                    </span>
                    <span *ngIf="!version.es_vigente" class="badge rounded-pill badge-light-secondary">No vigente</span>
                  </td>
                  <td class="text-center text-nowrap">
                    <button type="button" class="btn btn-sm btn-light" ngbTooltip="Visualizar archivo"
                      aria-label="Visualizar archivo" (click)="visualizarVersion(version)"
                      [disabled]="visualizandoId === version.id">
                      <span *ngIf="visualizandoId === version.id" class="spinner-border spinner-border-sm text-primary"
                        role="status" aria-hidden="true"></span>
                      <i *ngIf="visualizandoId !== version.id" class="fa fa-eye text-primary"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-light ms-1" ngbTooltip="Descargar archivo"
                      aria-label="Descargar archivo" (click)="descargarVersion(version)"
                      [disabled]="descargandoId === version.id">
                      <span *ngIf="descargandoId === version.id" class="spinner-border spinner-border-sm text-success"
                        role="status" aria-hidden="true"></span>
                      <i *ngIf="descargandoId !== version.id" class="fa fa-download text-success"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-light ms-1" ngbTooltip="Editar versión"
                      aria-label="Editar versión" (click)="editarVersion(version, modalEditarVersion)">
                      <i class="fa fa-edit text-primary"></i>
                    </button>
                    <button type="button" class="btn btn-sm btn-light ms-1"
                      [ngbTooltip]="version.es_vigente ? 'Es la versión vigente' : 'Marcar como vigente'"
                      aria-label="Marcar como vigente" [disabled]="version.es_vigente || vigenteId === version.id"
                      (click)="marcarComoVigente(version)">
                      <span *ngIf="vigenteId === version.id" class="spinner-border spinner-border-sm text-warning"
                        role="status" aria-hidden="true"></span>
                      <i *ngIf="vigenteId !== version.id" class="fa"
                        [ngClass]="version.es_vigente ? 'fa-star text-warning' : 'fa-star-o'"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div *ngIf="versiones.length === 0 && documento_id && !cargandoVersiones" class="text-center text-primary py-4 mt-3">
          <i class="fa fa-info-circle fa-2x mb-2 d-block"></i>
          <p class="mb-0">No hay versiones registradas para este documento</p>
        </div>
      </ng-template>
    </ngb-panel>

    <!-- PANEL 3: HISTORIAL DE CAMBIOS -->
    <ngb-panel id="static-3">
      <ng-template ngbPanelTitle>
        <i class="fa fa-list me-2 text-primary"></i>
        <span (click)="togglePanel('static-3')" class="fw-semibold">Historial de cambios</span>
      </ng-template>
      <ng-template ngbPanelContent>
        <div *ngIf="cargandoHistorial && historialCambios.length === 0" class="text-center text-primary py-4">
          <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Cargando historial...
        </div>
        <div class="table-responsive border rounded-3" *ngIf="historialCambios.length > 0; else sinHistorial">
          <table class="table table-hover align-middle mb-0">
            <thead class="table-light">
              <tr>
                <th>Versión</th>
                <th>Fecha</th>
                <th>Descripción</th>
                <th>Responsable</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cambio of historialCambios | paginate: { itemsPerPage: historialPageSize, currentPage: historialPage, id: 'historial-cambios' }">
                <td><span class="badge badge-light-info font-monospace">{{ cambio.version }}</span></td>
                <td class="text-nowrap">{{ cambio.fecha | date: 'HH:mm - dd/MM/yyyy' }}</td>
                <td style="white-space: pre-line">{{ cambio.descripcion }}</td>
                <td>{{ cambio.responsable }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="historialCambios.length > 0"
          class="d-flex flex-wrap align-items-center justify-content-between gap-3 mt-3">
          <div class="d-flex align-items-center gap-2 text-primary">
            <label for="historialPageSize" class="mb-0">Mostrar</label>
            <select id="historialPageSize" class="form-select form-select-sm w-auto" [(ngModel)]="historialPageSize"
              (change)="historialPage = 1">
              <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
            </select>
            <span>por página</span>
          </div>
          <div class="paginador-personalizado">
            <pagination-controls id="historial-cambios" (pageChange)="historialPage = $event" [maxSize]="5"
              [directionLinks]="true" [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
            </pagination-controls>
          </div>
        </div>
        <ng-template #sinHistorial>
          <div *ngIf="!cargandoHistorial" class="text-center text-primary py-4">
            <i class="fa fa-info-circle fa-2x mb-2 d-block"></i>
            <p class="mb-0">No hay registros de cambios disponibles</p>
          </div>
        </ng-template>
      </ng-template>
    </ngb-panel>

  </ngb-accordion>
</div>

<!-- Modal para editar versión -->
<ng-template #modalEditarVersion let-modal>
  <div class="modal-header">
    <h5 class="modal-title fw-semibold">Editar versión {{ versionEdit.numero_version }}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()" aria-label="Cerrar"></button>
  </div>

  <div class="modal-body">
    <form class="needs-validation" novalidate>
      <div class="row g-3">
        <div class="col-md-4">
          <label class="form-label" for="edit_numero_version">Número de versión</label>
          <input type="text" id="edit_numero_version" class="form-control" [(ngModel)]="versionEdit.numero_version"
            name="edit_numero_version" placeholder="01" disabled>
        </div>
        <div class="col-md-4">
          <label class="form-label" for="edit_fecha_aprobacion">Fecha de aprobación</label>
          <input type="date" id="edit_fecha_aprobacion" class="form-control" [(ngModel)]="versionEdit.fecha_aprobacion"
            name="edit_fecha_aprobacion" [max]="hoy">
        </div>
        <div class="col-md-4">
          <label class="form-label" for="edit_aprobado_por">Aprobado por</label>
          <input type="text" id="edit_aprobado_por" class="form-control" [(ngModel)]="versionEdit.aprobado_por"
            name="edit_aprobado_por" placeholder="Nombre del aprobador">
        </div>

        <div class="col-12">
          <label class="form-label" for="edit_archivo">Cargar archivo (opcional)</label>
          <input type="file" id="edit_archivo" class="form-control" (change)="onArchivoEdicionSeleccionado($event)"
            accept=".pdf,.doc,.docx,.xls,.xlsx"
            name="edit_archivo">
          <div class="form-text text-break" *ngIf="rutaEdicionPreview">
            Ruta GCP: <span class="font-monospace">{{ rutaEdicionPreview }}</span>
          </div>
        </div>

        <div class="col-12">
          <div class="border rounded-3 p-2 px-3"
            [ngClass]="versionEdit.es_vigente ? 'border-success bg-light-success' : 'bg-light'">
            <div class="form-check form-switch mb-0">
              <input type="checkbox" class="form-check-input" role="switch" id="chkVersionVigenteEdit"
                [(ngModel)]="versionEdit.es_vigente" name="edit_es_vigente">
              <label class="form-check-label fw-semibold" for="chkVersionVigenteEdit">
                <i class="fa fa-star me-1" [ngClass]="versionEdit.es_vigente ? 'text-warning' : 'text-muted'"></i>
                Marcar como versión vigente
              </label>
            </div>
            <small class="text-muted d-block ms-5">
              {{ versionEdit.es_vigente ? 'Reemplazará a la versión vigente actual.' : 'La versión se guardará como no vigente.' }}
            </small>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="guardarVersionEditada(modal)" [disabled]="guardandoEdicion">
      <span *ngIf="guardandoEdicion" class="spinner-border spinner-border-sm me-1" role="status"
        aria-hidden="true"></span>
      <i *ngIf="!guardandoEdicion" class="fa fa-save me-1"></i>{{ guardandoEdicion ? 'Guardando...' : 'Guardar cambios' }}
    </button>
  </div>
</ng-template>